export type DKSpaceOrigin = 'global' | 'local';

export enum DKSpaceOriginType {
  GLOBAL_SPACE = 'global',
  LOCAL_SPACE = 'local',
}
